import { Link } from "@tanstack/react-router"
import { Menu, X } from "lucide-react"
import { useState } from "react"

import LogoWithText from "@/components/logo-with-text"

const NAV_LINKS = [
  { label: "Methodology", to: "/methodology", isExternal: false },
  { label: "Top Markets", href: "/#markets", isExternal: true },
] as const

export default function ConsumerNav() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <header className="bg-background sticky top-0 z-50 border-b-2">
      <div className="flex items-stretch justify-between">
        <Link
          to="/"
          className="bg-foreground text-background flex min-w-[240px] items-center p-4 md:p-6"
        >
          <LogoWithText />
        </Link>

        <nav className="hidden items-stretch divide-x-2 md:flex">
          {NAV_LINKS.map((link) =>
            link.isExternal ? (
              <a
                key={link.label}
                href={link.href}
                className="wb-tag hover:bg-brand flex items-center px-8 transition-colors"
              >
                {link.label}
              </a>
            ) : (
              <Link
                key={link.label}
                to={link.to}
                className="wb-tag hover:bg-brand flex items-center px-8 transition-colors"
              >
                {link.label}
              </Link>
            )
          )}
        </nav>

        <div className="flex items-center p-4 md:hidden">
          <button
            className="bg-brand border-2 p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-expanded={isMenuOpen}
            aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          >
            {isMenuOpen ? (
              <X className="size-6" />
            ) : (
              <Menu className="size-6" />
            )}
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <nav className="border-t-2 md:hidden">
          {NAV_LINKS.map((link) =>
            link.isExternal ? (
              <a
                key={link.label}
                href={link.href}
                className="wb-tag hover:bg-brand block border-b px-6 py-4 transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                {link.label}
              </a>
            ) : (
              <Link
                key={link.label}
                to={link.to}
                className="wb-tag hover:bg-brand block border-b px-6 py-4 transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                {link.label}
              </Link>
            )
          )}
        </nav>
      )}
    </header>
  )
}
